<template>
  <span>{{ dicTxt || defaultText || '' }}</span>
</template>

<script>
export default {
  props: ["dicType", "dicCode", 'defaultText'],
  components: {},
  data() {
    return {
      dic:{},
    };
  },
  watch: {},
  computed: {
    dicTxt: function() {
      if(!this.dic){
        return "";
      }
      if (typeof this.dic[this.dicType] != "undefined") {
        for (var code in this.dic[this.dicType]) {
          if (code == this.dicCode) {
            return this.dic[this.dicType][code];
          }
        }
      } else {
        return "";
      }
    }
  },
  created() {
    this.dic = JSON.parse(localStorage.dic);
  },
  methods: {}
};
</script>
<style lang="scss"></style>
